import { createAction } from '@reduxjs/toolkit';

export type NotifyScoringFormsPayloadType<V = unknown> = {
  formCode: string;
  actionName: string;
  value: V;
};

export const notifyScoringFormsAction =
  createAction<NotifyScoringFormsPayloadType>('@ScoringForms/notifyForm');
